import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import BrandBlogPage from './BrandBlogPage';

export default function BlogPage() {
  return (
    <>
      <Navbar />
      <BrandBlogPage
        publisher="複刻文化"
        brandName="複刻文化"
        englishName="FUKO"
        tagline="從歷史與人文經典，重新理解今日的生活"
      />
      <Footer />
    </>
  );
}

